var GoldenEgg = require("components/games/GoldenEgg");
var CurrentUser = require("lib/account/CurrentUser");
var StudentAvatar = require("components/avatars/StudentAvatar");
var CoinDisplay = require("components/utility/CoinDisplay");
var Tiers = require("lib/games/Tiers");
var ProgressBar = require("components/utility/ProgressBar");
var ReactTooltip = require("react-tooltip");
var OwlShopRouting = require("lib/routing/OwlShopRouting");

const OwlShopActions = require("lib/actions/OwlShopActions");
const OwlShopSelectors = require("lib/selectors/OwlShopSelectors");

import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import React from "react";
import _ from "underscore";

require("users/students/gamified_student_display.scss");

@connect(
	(state, ownProps) => {
        var filteredPatches = OwlShopSelectors.getFilteredPatches({ state });
        //"false" argument specifies that the equipped background shouldn't 
        //be displayed on the student homepage background.
        var filteredPerks = OwlShopSelectors.getFilteredPerks({ state });
        var allFurnitures =  OwlShopSelectors.getFurnitures({ state });
        

        return {
            filteredPatches,
            filteredPerks,
            allFurnitures,
            ownedPatches: _.select(filteredPatches, function(patch) {
                            return patch.owned && patch.source == "store"
                        }),
            
            ownedPerks: _.select(filteredPerks, function(perk) {
                            return perk.owned && perk.source == "store"
                        }),
            filteredFurnitures: _.select(allFurnitures, function(furniture) {
                            return furniture.owned && furniture.source == "store";
                         })
        }
    },
	(dispatch, props) => ({
		populateData: () =>
		    Promise.all([
			    dispatch(OwlShopActions.fetchPatches()),
				dispatch(OwlShopActions.fetchPerks()),
				dispatch(OwlShopActions.fetchFurnitures()),
			])
	})
)
@providePopulateData()

class GamifiedStudentDisplay extends React.Component{
    constructor(props){
        super();
        autobind(this);
    }


    //get total number of items required for current level.
    getTierRequirementCount(){
        var total_required = 0;
        for (var[objType, reqs] of Object.entries(Tiers.REQUIREMENTS[this.props.student.tier])){
            total_required += Object.values(reqs).reduce((a, b) => a + b);
        }
        return total_required
    }

    getRemainingReqsCount(patches, perks, furnitures){
        if (!patches || !perks || !furnitures) { return 0 }

    	var tier = this.props.student.tier
            var reqs = Tiers.REQUIREMENTS[tier]  

            var remainingReqs = $wr.getRemainingReqs(tier, reqs, patches, perks, furnitures)
            if (!remainingReqs) { return 0 }
            
    	var remaining = 0;
        for (var [objType, reqs] of Object.entries(remainingReqs)){
            remaining += reqs
        }
        return remaining
    }

    redirectToTrophyRoom(){
        var params = "?openTrophyRoom=true"
        $wr.redirect(OwlShopRouting.getPath({})+params )
    }

    render(){
        var student = this.props.student

        if (this.props.student && this.props.student.is_clickable_egg) {
            var goldenEgg = (
              <GoldenEgg />
            );
        }

        var studentForAvatar = CurrentUser.get();
        var tierIconTooltipText = "Level " + (this.props.student.tier + 1) + ": " + Tiers.getName(this.props.student.tier);
        var remainingReqsCount =  this.getRemainingReqsCount(this.props.filteredPatches, this.props.filteredPerks, this.props.allFurnitures)
        var display =(
            <div className={"mainSection"}>
                <div className="name">
                    <span className="nameString">
                        {student ? $wr.fetchTitle(student) : ""}
                    </span>
                    <div className="eggContainer">
                        {goldenEgg}
                    </div>
                </div>
                <div className="panelContainer">
                    <div className="leftPanel">
                        <Link to={OwlShopRouting.getPath({})}>
                            <div className="avatarBackground">
                                <div className="owlvatar">
                                    <StudentAvatar student={studentForAvatar} maxWidth={150} />  
                                </div>
                                { $wr.hasBackgroundEquipped(this.props.ownedPerks) ?
                                    <div className="shadow" /> : ""}
                            </div>
                        </Link>
                    </div>
                    <div className="rightPanel">
                        <div className="sidePanel shopPanel">
                            <div className="progressContainer">
                                <div className="tierNumber" onClick={this.redirectToTrophyRoom}>
                                    <img
                                        src={Tiers.getIcon(this.props.student.tier)}
                                        className="currentTierImage"
                                        data-tip={tierIconTooltipText}
                                        height={40}
                                    />
                                </div>
                      
                                <div className="explanationString">
                                        {this.props.student.tier < 6 ? 
                                            <span> Buy {" " + remainingReqsCount + " "} more level
                                                {" " + (this.props.student.tier + 1).toString() + ' ' } items to level up!
                                            </span>
                                        : <span> You have maxed out your owl!</span>}
                                </div>
                            </div>

                            <div className="levelContainer">
                                <div className="progressBar">
                                    <ProgressBar current={ this.props.student.tier < 6 ? (this.getTierRequirementCount() - remainingReqsCount): 1 }
                                        total={this.props.student.tier < 6 ? this.getTierRequirementCount(): 1} className="levelBar"/>
                                </div>           
                            </div>
                            <div className="coinsContainer">
                                <div data-tip='Spend coins to unlock missing items and level up!'>
                                    <Link to={OwlShopRouting.getPath({})}>
                                        <CoinDisplay coins={this.props.student.coins } height={20}/>
                                    </Link>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        )
        return display
    }

    //adds a background circle behind the student avatar
    componentDidMount(){
        var userBackground = this.props.student.perks.backgrounds
        if (userBackground != ""){
            var $avatarBackground = $(".avatarBackground");
		    var perkPath = dynamicRequire("perks/backgrounds/" + userBackground.toLowerCase() + ".png");
		    $avatarBackground.addClass("hasBackground").css('background', 'url(' + perkPath + ')');
            $avatarBackground.addClass("backgroundBorder")
            var $owlvatar = $(".owlvatar")
            $owlvatar.addClass("centeredOwl")
            $(".rightPanel").addClass('adjustedRightPanel')
        }
    }
}


module.exports = GamifiedStudentDisplay;



// WEBPACK FOOTER //
// ./modules/components/users/students/GamifiedStudentDisplay.js